import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCardGiftGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 9.34 9.542 7.894A3.024 3.024 0 0 0 5.15 9.51 1 1 0 0 0 5 9.5H3v2h2q.077 0 .15-.011a3.024 3.024 0 0 0 4.392 1.618l.052-.032-.488.978a1 1 0 1 0 1.788.894L12 12.737l1.106 2.21a1 1 0 1 0 1.788-.894l-.488-.978.052.031a3.024 3.024 0 0 0 4.392-1.617q.074.01.15.011h2v-2h-2q-.076 0-.15.011a3.024 3.024 0 0 0-4.392-1.617zm-3.472.278a1.024 1.024 0 1 0 0 1.765l1.5-.883zm5.444.882 1.5.883a1.024 1.024 0 1 0 0-1.765z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M4 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM1 7a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3z'
      clipRule='evenodd'
      opacity={0.6}
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCardGiftGhostLine)
export default ForwardRef
